// extracted by mini-css-extract-plugin
export default {"container":"dcc_cornerRibbon-container","text":"dcc_cornerRibbon-text"};